import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Col, Row, Layout, Button } from 'antd';
import { DownloadOutlined, DeploymentUnitOutlined } from '@ant-design/icons';
import { DateContext } from '../Context/DateContext';
import { ThemeContext } from '../Context/ThemeContext';
import { ProfileContext } from '../Context/ProfileContext';
import * as pwa from '../../installPWA';

const { Header } = Layout;
const { Text } = Typography;

export default function TimeHeader(props) {
  const history = useHistory();
  const { currentDate } = useContext(DateContext);
  const { theme } = useContext(ThemeContext);
  const { loggedin } = useContext(ProfileContext);
  return (
    <div>
      <Header
        style={{
          background: theme.header.bg,
          position: 'fixed',
          zIndex: 1,
          width: '100%',
        }}
      >
        <Row>
          <Col xs={0} sm={0} md={4} lg={6} />
          <Col xs={24} sm={24} md={16} lg={12}>
            <Row>
              <Col xs={18} sm={20}>
                <Text style={{ color: theme.header.text }}>
                  {new Date(currentDate).toDateString()}
                </Text>
              </Col>
              {/* Installation */}
              <Col
                xs={4}
                sm={2}
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <Text
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                  onClick={pwa.install}
                >
                  <Button
                    className='install-app-button install-app-container hidden'
                    size='large'
                    shape='circle-outline'
                    type={theme.label === 'Dark' ? 'primary' : 'default'}
                    title='Install App'
                  >
                    <DownloadOutlined />
                  </Button>
                </Text>
              </Col>
              <Col
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: loggedin ? 'block' : 'none',
                }}
                xs={2}
                sm={2}
              >
                <Text
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                  onClick={() => {
                    history.push('/explore');
                  }}
                >
                  <Button
                    size='large'
                    shape='circle-outline'
                    type={theme.label === 'Dark' ? 'primary' : 'default'}
                    title='Home'
                  >
                    <DeploymentUnitOutlined />
                  </Button>
                </Text>
              </Col>
              <Col sm={0} md={4} lg={6} />
            </Row>
          </Col>
          <Col xs={0} sm={0} md={4} lg={6} />
        </Row>
      </Header>
    </div>
  );
}
